import React from 'react';
import styled from "styled-components";

const SGrammarPronombres = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarPronombres = () => {
  return (
  <SGrammarPronombres>
<h5>Pronombres - Zaimki</h5>

<p>
<li><a href="#osob">Zaimki osobowe podmiotu</a></li>
<li><a href="#dopel_bl">Zaimki osobowe dopełnienia bliższego</a></li>
<li><a href="#dopel_dal">Zaimki osobowe dopełnienia dalszego</a></li>
<li><a href="#zwrotne">Zaimki zwrotne</a></li>
<li><a href="#dzierz">Zaimki dzierżawcze</a></li>
<li><a href="#wskaz">Zaimki wskazujące</a></li>
</p>
<p>Poza powyższymi zaimkami istnieją jeszcze zaimki względne, pytajne i nieokreślone.</p>

<a name="osob"/><h6>Zaimki osobowe podmiotu</h6>
<table>
<tr><td><b>yo<br/>tú<br/>él, ella, usted<br/>nosotros<br/>vosotros<br/>ellos, ellas, ustedes</b></td><td>- ja<br/>- ty<br/>- on, ona, pan/pani<br/>- my<br/>- wy<br/>- oni, one, państwo</td></tr>
</table>
<br/>Zaimków osobowych używa się prawie wyłącznie wtedy, kiedy chcemy podkreślić albo odróżnić podmiot od innych osób.

<a name="dopel_bl"/><h6>Zaimki osobowe dopełnienia bliższego</h6>
<table>
<tr><td><b>me<br/>te<br/>lo, la<br/>nos<br/>os<br/>los, las</b></td><td>- mnie<br/>- ciebie<br/>- jego/pana, ją/panią<br/>- nas<br/>- was<br/>- ich/panów, je/panie</td></tr>
</table>
<br/>W języku polskim najczęściej zaimkom tym odpowiada biernik KOGO? CO?:<br/>
<i>Conoce usted a este senor? Si, lo conozco</i> - Zna pan tego pana? Tak, znam go

<a name="dopel_dal"/><h6>Zaimki osobowe dopełnienia dalszego</h6>
<table>
<tr><td><b>me<br/>te<br/>le/se<br/>nos<br/>os<br/>les/se</b></td><td>- mnie, mi<br/>- tobie<br/>- jemu, jej, panu, pani<br/>- nam<br/>- wam<br/>- im, państwu</td></tr>
</table>
<br/>To dopełnienie odpowiada polskiemu celownikowi KOMU? CZEMU?

<a name="zwrotne"/><h6>Zaimki zwrotne</h6>
W odróżnieniu od polskiego, zaimek zwrotny <i>się</i> po hiszpańsku ma oddzielną formę dla każdej osoby (w przykładzie dla czas. <i>lavarse</i> - myć się):
<table>
<tr><td><b>me<br/>te<br/>se<br/>nos<br/>os<br/>se</b></td><td>- <b>me</b> lavo<br/>- <b>te</b> lavas<br/>- <b>se</b> lava<br/>- <b>nos</b> lavamos<br/>- <b>os</b> laváis<br/>- <b>se</b> lavan</td></tr>
</table>

<a name="dzierz"/><h6>Zaimki dzierżawcze:</h6>
<table>
<tr><td><b>mi<br/>tu<br/>su<br/>nuestro, nuestra<br/>vuestro, vuestra<br/>su</b></td><td>- mój, moja<br/>- twój, twoja<br/>- jego, jej<br/>- nasz, nasza<br/>- wasz, wasza<br/>- ich</td></tr>
</table>
<br/>Jeśli rzecz, którą się posiada, występuje w liczbie mnogiej, to zaimki też zmieniają swoją liczbę na mnogą.

<a name="wskaz"/><h6>Zaimki wskazujące</h6>
Istnieją trzy typy tych zaimków, w zależności od usytuowania rzeczy wskazywanej:
<table>
<tr><td><b>este, esta, estos, estas<br/>ese, esa, esos, esas<br/>aquel, aquella, aquellos, aquellas</b></td><td>- ten, ta, ci, te<br/>- tamten, tamta, tamci, tamte<br/>- ów, owa, owi, owe</td></tr>
</table>
  </SGrammarPronombres>
  )
};

export default GrammarPronombres;